import React from "react";
import { Button } from "antd";
import { useMediaQuery } from "react-responsive";

const UnFollow = ({ onClick, text }) => {
const isMobile = useMediaQuery({maxWidth: 1024})
  return (
    <Button
      onClick={onClick}
       style={{
              background: "#f18b6f",
              borderColor: "#f18b6f",
              color: "white",
              padding: "12px 10px",
              fontSize: isMobile ? "12px": "16px",
              fontWeight: "bold",
              borderRadius: "999px",
              minWidth: "10px",
            }}
    >
      {text}
    </Button>
  );
};

export default UnFollow;
